import React, { useRef } from "react";
import { BUSINESS } from "@/data/business";
import { Calendar } from "lucide-react";

/**
 * Primary call-to-action that opens the Square booking page in a new tab.
 * Includes a subtle "magnetic" pull toward the cursor (desktop only) and a sheen sweep.
 */
export const BookButton = ({
  className = "",
  variant = "primary",
  testId = "book-appointment-button",
  children,
  withIcon = true,
}) => {
  const ref = useRef(null);

  const handleMagnet = (e) => {
    const el = ref.current;
    if (!el || window.matchMedia("(pointer: coarse)").matches) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const r = el.getBoundingClientRect();
    const dx = (e.clientX - r.left - r.width / 2) * 0.12;
    const dy = (e.clientY - r.top - r.height / 2) * 0.3;
    el.style.transform = `translate(${dx.toFixed(1)}px, ${dy.toFixed(1)}px)`;
  };

  const resetMagnet = () => {
    if (ref.current) ref.current.style.transform = "translate(0px, 0px)";
  };

  const base =
    "sheen inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold tracking-wide transition-[background-color,box-shadow,transform] duration-300 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--bg)]";

  const variants = {
    primary: "btn-glass-dark btn-glow",
    secondary: "btn-glass-light",
    outline: "btn-glass-light",
    bright: "btn-glass-bright btn-glow",
  };

  return (
    <a
      ref={ref}
      href={BUSINESS.bookingUrl}
      target="_blank"
      rel="noreferrer"
      data-testid={testId}
      onPointerMove={handleMagnet}
      onPointerLeave={resetMagnet}
      className={`${base} ${variants[variant]} ${className}`}
      style={{ willChange: "transform" }}
    >
      {withIcon && <Calendar size={16} strokeWidth={1.75} />}
      {children || "Book Appointment"}
    </a>
  );
};
